import type { TypedLocale } from 'payload'
import type { Navigation } from '@/payload-types'

export const NAVIGATION_FILTERS = {
  animals: {
    en: ['dog', 'cat'],
    de: ['hund', 'katze'],
    pl: ['pies', 'kot'],
  },
  productTypes: {
    en: ['food', 'product'],
    de: ['futter', 'produkt'],
    pl: ['karma', 'produkt'],
  },
  productReferences: ['productCategoryId'],
} as const

// Minimal shape of a navigation item we care about for filtering
type NavItem = Pick<Navigation['links'][number], 'label' | 'reference_type'> & {
  productsCategoryId?: string | null
}

export const isRelevantNavItem = (item: NavItem, locale: TypedLocale): boolean => {
  const label = item.label.toLowerCase()
  const animals = NAVIGATION_FILTERS.animals[locale] || NAVIGATION_FILTERS.animals.en
  const productTypes =
    NAVIGATION_FILTERS.productTypes[locale] || NAVIGATION_FILTERS.productTypes.en

  const hasAnimal = animals.some((animal) => label.includes(animal))
  const hasProductType = productTypes.some((product) => label.includes(product))
  const hasProductReference =
    item.reference_type === 'productCategoryId' || Boolean(item.productsCategoryId)

  return hasAnimal && (hasProductType || hasProductReference)
}
